// ─── Fiche d'un repas (composition) — LECTURE SEULE ────────────────
// Clic sur un repas = cette fiche (jamais l'édition directe). ✏️, 🛒 et 🗑️
// dans l'en-tête. `recettesById` sert à résoudre les noms des recettes
// composées.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, HIT, useUI, useT } from '@mop/core';
import { coutRepas } from './services/repasComposes';

export default function FicheRepas({ visible, repas, recettesById = {}, onFermer, onEditer, onSupprimer, onAjouterListe }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  if (!visible || !repas) return null;

  const cout = coutRepas(repas, recettesById);
  const recettes = repas.recettes || [];
  const extras = repas.extras || [];

  return (
    <Feuille visible titre={repas.nom} emoji={repas.icone || '🍽️'} onFermer={onFermer}
      boutons={(
        <>
          {/* 🛒 ne fait qu'OUVRIR la feuille d'ajout, rendue au niveau de
              l'écran : deux <Modal> natives imbriquées figent l'app. */}
          <TouchableOpacity onPress={onAjouterListe} hitSlop={HIT} accessibilityLabel={t('courses.ajouterALaListe')}>
            <Text style={s.hIc}>🛒</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onEditer} hitSlop={HIT} accessibilityLabel={t('commun.editer')}>
            <Text style={s.hIc}>✏️</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onSupprimer} hitSlop={HIT} accessibilityLabel={t('commun.supprimer')}>
            <Text style={[s.hIc, { color: UI.danger }]}>🗑️</Text>
          </TouchableOpacity>
        </>
      )}>

      <View style={s.entete}>
        <Text style={s.sous}>{repas.personnes} {t('repas.personnes')}</Text>
        {cout > 0 && <Text style={s.cout}>{cout.toFixed(2)} €</Text>}
      </View>

      <Text style={s.sect}>{t('repas.recettes')}</Text>
      {recettes.length === 0 ? <Text style={s.vide}>—</Text> : recettes.map((x, idx) => (
        <Text key={idx} style={s.ligne}>
          • {recettesById[x.recetteId]?.nom || t('repasPlan.recetteSupprimee')} ({x.personnes} {t('repas.perServ')})
        </Text>
      ))}

      <Text style={s.sect}>{t('repas.extras')}</Text>
      {extras.length === 0 ? <Text style={s.vide}>—</Text> : extras.map((e, idx) => (
        <Text key={idx} style={s.ligne}>• {[e.quantite, e.unite, e.nom].filter(Boolean).join(' ')}</Text>
      ))}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  hIc: { fontSize: 18, color: UI.accent },
  entete: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 },
  sous: { fontSize: 13.5, color: UI.muted },
  cout: { fontSize: 15, fontWeight: '800', color: UI.ink },
  sect: { fontSize: 12, fontWeight: '800', color: UI.accent, textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 16, marginBottom: 8 },
  ligne: { fontSize: 14.5, color: UI.ink, marginBottom: 6, lineHeight: 20 },
  vide: { fontSize: 13, color: UI.faint },
});
